import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

const relationshipPage: FlowPage = {
  slug: () => 'relationship',
  isEnabled: () => true,
  title: () => 'What is your relationship to this home?',
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.relation_to_owner',
      type: 'exclusives_radio_single_select',
      options: [
        {
          label: 'I am the owner of this home',
          value: 'Self',
        },
        {
          label: 'I am a realtor or agent',
          value: 'Agent',
        },
        {
          label: 'I am both the homeowner and an agent',
          value: 'AgentAndOwner',
        },
        {
          label: 'Other',
          value: 'other',
          followUps: [
            {
              key: 'seller.relation_to_owner.other',
              type: 'single_line',
              label: 'Describe your relationship',
            },
          ],
        },
      ],
    },
  ],
};

export default relationshipPage;
